import { faAngleLeft, faAngleRight } from "@fortawesome/pro-duotone-svg-icons";
import { computed } from "@preact/signals-react";
import { ListView } from "@progress/kendo-react-listview";
import { ColorChangingIcon } from "../Common/UI/ColorChangingIcon";
import { fieldPropertyMap } from "../Fields/PropertyTypes/FieldPropertyMap";
import {
  fieldFocusIndex,
  propertiesVisible,
  sectionFocusIndex,
  selectedFieldName,
  selectedFieldPropertyValues,
  selectedFieldType,
  selectedSectionName,
  templateData,
} from "./NewTemplateSignals";

//#region Signals
const fieldProperties = computed(() => {
  return fieldPropertyMap[selectedFieldType.value]?.template?.map((property) => ({
    ...property,
    hidden: !propertiesVisible.value,
  }));
});
const items = computed(() => {
  return [
    {
      id: 0,
      renderer: function () {
        return (
          <div className="align-columns">
            <ColorChangingIcon
              icon={propertiesVisible.value ? faAngleRight : faAngleLeft}
              onClick={() => (propertiesVisible.value = !propertiesVisible.value)}
              initialPrimaryColor="#0078d4"
              initialSecondaryColor="#0078d4"
              initialSize={32}
              hoverSize={32}
              margin="10px 0 0 10px"
            />
            {propertiesVisible.value && (
              <h2 style={{ margin: "10px 0 0 0" }}>
                {selectedFieldName.value ?? selectedSectionName.value} Properties
              </h2>
            )}
          </div>
        );
      },
    },
  ].map((item) => ({ ...item }));
});
const propertiesWithHeaders = computed(() => {
  const groupByCategory = (properties) => {
    if (!Array.isArray(properties)) return {};

    return properties?.reduce((acc, prop) => {
      if (!acc[prop.propertyCategory]) {
        acc[prop.propertyCategory] = [];
      }
      acc[prop.propertyCategory].push(prop);
      return acc;
    }, {});
  };

  const categorizedProperties = groupByCategory(fieldProperties.value);

  return Object.entries(categorizedProperties).flatMap(([category, props]) => [
    {
      isHeader: "true",
      category,
      renderer: function () {
        return (
          <div className="property-category">
            <h3>{category}</h3>
          </div>
        );
      },
    },
    ...props,
  ]);
});
//#endregion

const ItemRender = ({ props }) => {
  const handlePropertyChange = ({ propName, propValue }) => {
    if (fieldFocusIndex.value === null) {
      templateData.value = {
        ...templateData.value,
        sections: templateData.value.sections.map((section, index) => {
          if (index === sectionFocusIndex.value) {
            return {
              ...section,
              properties: {
                ...section.properties,
                [propName]: propValue,
              },
            };
          }
          return section;
        }),
      };
    } else {
      templateData.value = {
        ...templateData.value,
        sections: templateData.value.sections.map((section, index) => {
          if (index === sectionFocusIndex.value) {
            return {
              ...section,
              fields: section.fields.map((field, index) => {
                if (index === fieldFocusIndex.value) {
                  return {
                    ...field,
                    properties: {
                      ...field.properties,
                      [propName]: propValue,
                    },
                  };
                }
                return field;
              }),
            };
          }
          return section;
        }),
      };
    }
  };

  if (props.dataItem.id === 0) {
    return props.dataItem.renderer();
  }
  if (!propertiesVisible.value) {
    return;
  }
  if (props.dataItem.isHeader) {
    return props.dataItem.renderer();
  }

  return (
    <div className="align-rows">
      {props.dataItem.propertyDisplay}:
      {props.dataItem.renderer({
        handlePropertyChange,
        currentPropertyValues: selectedFieldPropertyValues.value,
        fieldType: selectedFieldType.value,
        isGalleryEditor: false,
      })}
    </div>
  );
};

export const TemplatePropertyPane = () => {
  return (
    <div className="gallery-constructor-drawer">
      <ListView
        style={{
          backgroundColor: "var(--atlas-bg-primary)",
          borderBottomRightRadius: "20px",
          overflowY: "auto",
        }}
        className={"gallery-constructor-drawer"}
        data={[...items.value, ...propertiesWithHeaders.value]}
        item={(props) => ItemRender({ props })}
      />
    </div>
  );
};
